<script>
import QRCodeStyling from 'qr-code-styling';

export default {
  name: 'QRCode',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      qrCode: null, // Property for the QR code instance
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    url: function (newVal) {
      this.qrCode.update({
        data: newVal,
      });
    },
  },
  mounted() {
    this.qrCode = new QRCodeStyling({
      width: 300,
      height: 300,
      data: this.url,
      image: '',
      dotsOptions: {
        color: '#645298',
        type: 'rounded',
      },
      backgroundOptions: {
        color: '#fff',
      },
    });
    this.qrCode.append(document.getElementById('qr-code-canvas'));
  },
  methods: {
    downloadQRCode(extension) {
      this.qrCode.download({ name: 'qr', extension });
    },
  },
};
</script>

<template>
  <div class="qr-builder flex flex-col items-center justify-center p-5">
    <div class="settings-container flex flex-col items-center">
      <div class="settings-content flex flex-col items-center">
        <div id="qr-code-canvas" />
        <button @click="downloadQRCode('png')">Download PNG</button>
        <button @click="downloadQRCode('svg')">Download SVG</button>
      </div>
    </div>
  </div>
</template>
